
<template>
    <!-- <div class="img-upload">
        <div class="img-upload-body"> -->
          <div class="img-upload img-upload-body">
            <div v-if="isInitial">
              <label>
                <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
              </label>              
              <div class="img-upload-btn-container">
                <button class="button-small" v-on:click="addFiles()">
                  <i class="fas fa-folder-open mr-2"></i>Browse files
                </button>&nbsp;
              </div>
              <div>
                <div v-for="(file, key) in files" v-bind:key="key" class="row border-top mt-2 pb-2" :class="key == files.length -1 ? 'border-bottom' : ''">
                  <div class="col-4 mt-2">
                    <div class="img-wrap">
                      <span class="close" v-on:click="removeFile( key )">&times;</span>
                    <img v-if="checkMime(file)" :id="'file_thumb_' + key" :ref="'file_thumb_' + key" :src="createObjectUrl('file_thumb_' + key, file)" :alt="'your file - ' + file.name" class="img-thumbnail_xxx" style="max-width:200px" />
                    <img v-else :id="'file_thumb_' + key" :ref="'file_thumb_' + key" src="/img/512x512.png" :alt="'your file - ' + file.name" class="img-fluid" style="max-width:200px" />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="files && files.length > 0" class="img-upload-btn-container mt-3">
                <button id="upload" ref="upload" class="button-small" v-bind:class="{'flash-button' : isFilesToUpload}" v-on:click="submitFiles()" :disabled = "!isFilesToUpload">
                  <i class="fas fa-file-upload mr-2"></i>Upload
                </button>
              </div>
            </div>
            
            <div v-if="isSaving">
              <div class="spinner-border" role="status">
                <span class="sr-only">Uploading file(s)...</span>
              </div>
            </div>

            <div v-if="isSuccess">
                <section v-if="uploadResponse.data">
                  <h3>Uploaded {{ uploadResponse.data.length }} file(s) successfully.</h3>
                  <p><a href="javascript:void(0)" @click="reset()">Upload again</a></p>
                </section>
                <ul class="list-unstyled">
                    <li v-for="(message, index) in uploadResponse.messages" :key="index">
                        {{message.body}}
                    </li>
                </ul>
            </div>

            <div v-if="isFailed">
                <h2>Upload failed.</h2>
                <p><a href="javascript:void(0)" @click="reset()">Try again</a></p>

                <ul class="list-unstyled">
                    <li v-for="(message, index) in uploadResponse.messages" :key="index">
                        {{message.body}}
                    </li>
                </ul>
            </div>
          </div>
        <!-- </div>
    </div> -->
</template>

<script>

import axios from 'axios'

let baseUrl = process.env.VUE_APP_API_BASE_URL

const STATUS_INITIAL = 0; const STATUS_SAVING = 1; const STATUS_SUCCESS = 2; const STATUS_FAILED = 3; const STATUS_FILES = 4

export default {
  props: {
    value: { required: false },
    entityRef: { required: true },
    entityType: { required: true },
    fileType: { required: true },
    optionRef: { required: false, default: null }
  },
  components: {
    
  },
  data () {
    return {

      isLoading: false,
      fullPage: true,

      ref: '',
      refType: '',
      docType: '',

      files: [],

      uploadResponse: {},

      currentStatus: STATUS_INITIAL
    }
  },
  mounted () {
    this.reset()
  },
  watch: {
    currentStatus: function () {
      this.$emit('status', this.currentStatus)
    },
    isFilesToUpload: function (val) {
      if (val) { process.nextTick(() => this.$refs.upload.focus()) }
    }
  },
  computed: {
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    isFilesToUpload () {
      return this.files.length > 0
    }
  },
  methods: {
    createObjectUrl(ref, file) {
      //console.log(ref)
      //console.log(this.$refs[ref])
      try {

        //this.$refs[ref].src = window.URL.createObjectURL(file)
        return window.URL.createObjectURL(file);
      } catch(err) {
        console.log(err)
      }
    },
    reset () {
      this.currentStatus = STATUS_INITIAL
      this.files = []
      this.uploadResponse = {}
    },
    handleFilesUpload () {
      let uploadedFiles = this.$refs.files.files

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },
    addFiles () {
      this.$refs.files.click()
    },
    removeFile (key) {
      this.files.splice(key, 1)
    },
    submitFiles () {
      this.isLoading = true
      this.currentStatus = STATUS_SAVING

      let formData = new FormData()

      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i]

        formData.append('files[' + i + ']', file)
      }

      let apiEndpoint

      if (this.optionRef != null) {
        formData.append('optionRef', this.optionRef)
        apiEndpoint = '/api/v1/document/uploadincoptionlink/'
      } else {
        apiEndpoint = '/api/v1/document/upload/'
      }

      if (this.entityRef) {
        axios
          .post(baseUrl + apiEndpoint + this.entityRef + '/' + this.entityType + '/files/' + this.fileType + '/', formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
          .then(response => {
            this.currentStatus = STATUS_SUCCESS
            this.uploadResponse = response.data
           
            this.$emit('input', this.uploadResponse.data)
          })
          .catch(() => {
            this.currentStatus = STATUS_FAILED
          })
          .finally(() => {
            this.isLoading = false
            this.files  = []
          })
      } else {
        this.currentStatus = STATUS_FAILED
        this.isLoading = false
      }
    },
    whenCancelled () {},
    checkMime(file) {
      var mimes = ['image/jpeg','image/png']
      return mimes.includes(file.type)
    }
  }
}
</script>
<style scoped>
.img-wrap {
    position: relative;
    display: inline-block;
    /* border: 1px red solid; */
    font-size: 0;
}
.img-wrap .close {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 100;
    background-color: #FFF;
    padding: 5px 2px 2px;
    color: #000;
    font-weight: bold;
    cursor: pointer;
    /* opacity: .2; */
    opacity: 1;
    text-align: center;
    font-size: 22px;
    line-height: 10px;
    border-radius: 50%;
}
/* .img-wrap:hover .close {
    opacity: 1;
} */
</style>
